import React from "react";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import Navbar from "./Navbar";
import "./style.css";

const Layout = ({ children }) => {
  return (
    <div className="site-body">
      <Helmet>
        <html lang="cs" />
      </Helmet>
      <Navbar />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
